import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { VehiclesDto } from '../dto/VehiclesDto';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import {EnvironmentService} from '@nw/ui-core-shared/services';

@Injectable()
export class VehiclesService {
    private userId: string;
    private urlParams: any;

    constructor(private httpClient: HttpClient, private environment: EnvironmentService,
                private route: ActivatedRoute) {
        this.route.queryParamMap.subscribe(params => {
            this.urlParams = params;
        });
    }

    loadVehicles(userId, queryParams): Observable<VehiclesDto> {
        const showRecommendation = this.environment.getEnvironment().watchlist.showRecommendation;
        this.userId = userId;
        let watchlistUrl;
        if (this.urlParams.params && this.urlParams.params['apiVersion']) {
            if (showRecommendation !== undefined && showRecommendation) {
                watchlistUrl = `api/watchlist/v${this.urlParams.params['apiVersion']}/${this.userId}/vehicles?orgId=${queryParams['orgId']}&${queryParams['sort']}${queryParams['filter']}`;
            } else {
                watchlistUrl = `api/watchlist/v${this.urlParams.params['apiVersion']}/${this.userId}/vehicles?${queryParams['sort']}${queryParams['filter']}`;
            }
        } else {
            if (showRecommendation !== undefined && showRecommendation) {
                watchlistUrl = `api/watchlist/${this.userId}/vehicles?orgId=${queryParams['orgId']}&${queryParams['sort']}${queryParams['filter']}`;
            } else {
                watchlistUrl = `api/watchlist/${this.userId}/vehicles?${queryParams['sort']}${queryParams['filter']}`;
            }
        }
        return this.httpClient.get(watchlistUrl)
            .map(res => res)
            .catch((error: any, o: any) => {
                return Observable.throw(error);
            });
    }

    removeVehicle(vehicleId: string): Observable<string> {
        // todo userId
        // todo confirm endpoint.

        return this.httpClient.delete(`/api/watchlist/${this.userId}/vehicles/${vehicleId}`)
            .map(() => vehicleId)
            .catch((error: any, o: any) => {
                return Observable.throw(error);
            });

    }

    removeAllVehicles() {
        return this.httpClient.delete(`/api/watchlist/${this.userId}/vehicles`)
            .map( () => true)
            .catch( (err) => {
                return Observable.throw(err);
            })
    }

    exportFn(url) {
        return this.httpClient.get(url)
            .map( (res) => {
            return res;
        }).catch((err) => {
            return Observable.throw(err);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/services/vehicles.service.ts